export enum MessageInstagramDmKind {
  Mention = "mention",
  Reply = "reply",
}
